(function () {
    'use strict';

    angular
        .module('sod.helper')
        .directive('customCart', customCart);

    function customCart(lodash) {
        return {
            restrict: 'E',
            controller: customCartCtrl,
            scope: {
                options: '=?',
                addToCart: '&'
            },
            require: 'ngModel',
            templateUrl: function(tElement, tAttrs) {
                // if (lodash.has(tAttrs, 'templateName')) {
                //     return tAttrs.templateName;
                // } else {
                    return 'common/components/cart/cart';
                // }
            },
            link: function(scope, elem, attr, ctrl) {
                scope.mdlCtrl = ctrl;

                ctrl.$formatters.push(function(modelValue) {
                    if (!lodash.has(modelValue, 'selected')) {
                        modelValue.selected = [];
                    }
                   return modelValue;
                });

                ctrl.$render = function() {
                    console.log('render ran');
                    scope.model = ctrl.$viewValue;
                }
            }
        };
    }

    function customCartCtrl($scope, lodash) {
        var field_name;

        this.$onInit = function() {
            field_name = lodash.get($scope.options, 'field_to_compare', 'name');

            $scope.ctrl = {
                getTemplate: getTemplate,
                addToCart: addToCart,
                removeFromCart: removeFromCart,
                isActive: isActive,
                removeAllFromCart: removeAllFromCart,
            };
            $scope.model = null;
            init();
        }

        function init() {
            console.log('init ran');
        }

        function getTemplate(type) {
            var templateName = lodash.get($scope.options, 'templates.' + type, false);
            return (!templateName) ? '' : templateName;
        }

        function addToCart(param) {
            // $scope.model.sele
            $scope.model.selected.push(param.item);
            $scope.mdlCtrl.$setViewValue($scope.model);
        }

        function removeFromCart(param) {
            var index = lodash.findIndex($scope.model.selected, { [field_name]: param.item[field_name] });
            $scope.model.selected.splice(index, 1);
        }

        function isActive(param) {
            console.log('isActive func called');
            return (lodash.findIndex($scope.model.selected, { [field_name]: param.item[field_name] })) >= 0;
        }

        function removeAllFromCart() {
            $scope.model.selected = [];
        }

    }
})();